import React from "react";
import Langswitcher from "../Langswitcher/Langswitcher";

import logo from '../../../Assets/Images/sb1fo.svg';
import nnLogo from '../../../Assets/Images/rgb_SB1_Finans_Nord_Norge_verti_pos.png';
import { config } from "../../../functions/config";

import styles from './Header.module.scss';

function Header() {
    return (
        <div className={styles.header}>
            <div className={styles.logo}>
                {config.region == "NORD" ? 
                    <img src={nnLogo} alt="logo" className={styles.nnLogo} />
                :  (config.region == "ØST" ? 
                    <img src={logo} alt="logo" /> 
                : null )
                }
            </div>
            {/* <div className={styles.langswitcher}>
                <Langswitcher />
            </div> */}
        </div>
    );
};

export default Header;